export default {
  main: {
    site_id: 5561,
    title: "Terminal Pro",
    logoSize: "big",
    hotjarId: 4937898,
    websitePasswordHash: "c9ca9ba1d6645792f9a077fb9e8859ba020398d4130c7a870239afe99cc071ec",
    homeMediaSlides: [
      {
        type: "sport",
        path: "betting/prematch",
      },
    ],
    availableLanguages: {
      "@replace": true,
      eng: {
        short: "EN",
        name: "ENG",
        region: "UnitedKingdom",
        order: 1,
      },
      spa: {
        short: "ES",
        name: "Esp",
        region: "Peru",
        order: 2,
      },
    },
  },
  env: {
    lang: "spa",
  },
  routes: [
    {
      url: "betting/live",
      name: "Live",
      enabled: true,
      icon: 'circle',
    },
    {
      name: "Sports",
      url: "betting/prematch/all",
      type: "sportsBook",
      enabled: true,
      nestedItems: [
        {
          url: 'betting/prematch/all',
          type: 'prematch',
          name: 'All Matches',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betting/prematch/betBuilder',
          type: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'betting/prematch/outrights',
          name: 'Outrights',
          type: 'outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'betting/prematch/popular',
          type: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
      ],
    },
    {
      url: 'betting/prematch/virtuals',
      type: 'virtuals',
      name: 'Virtuals',
      enabled: true,
      icon: 'casino-categories-VirtualBetting',
      nestedItems: [
        {
          name: 'Games',
          url: 'betting/prematch/virtuals',
          enabled: true,
          type: 'virtuals',
          icon: '',
        },
        {
          name: 'Results',
          type: 'virtual-results',
          url: 'betting/virtual-results',
          enabled: true,
          icon: '',
        },
      ],
    },
    {
      url: "betting/results",
      name: "Results",
      enabled: true,
    },
    {
      url: "tickets",
      name: "Tickets",
      enabled: true,
    },
  ],
  lastTicketButtons: [
    {
      name: "Bet tickets",
      type: "betTicket",
      hideOnRestrictMode: false,
    },
  ],
  defaultTerminalParams: { pid: 5561, tid: 19915, token: "HhmaEA==", currency: "PEN" },

  sportsbook: {
    enablePredefinedMultiples: false,
    enableBoostedOdds: false,
    sportList: {},
  },
  betslip: {
    enableCounterOffer: false,
    enableBookingBet: false,
    disableCounterOfferOnLive: false,
    enableBookingId: true,
    betDetailsOrder: ["total_odd", "stake_without_tax", "total_stake", "min_possible_win", "total_win"],
  },
};
